import type {Thread} from '@github-ui/diff-lines/conversation-types'

import {getFirstComment} from '../../../page-data/payloads/thread-previews'
import {ChevronRightIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {PreviewAuthors} from './PreviewAuthors'
import {useNavigateToFirstComment} from './use-navigate-to-first-comment'

type Props = {
  thread: Thread
  onNavigateToDiffComment: () => void
}

export const NavigateToCommentButton = ({thread, onNavigateToDiffComment}: Props) => {
  const firstComment = getFirstComment(thread)
  const navigateToFirstComment = useNavigateToFirstComment(thread, onNavigateToDiffComment)

  const isOutdated = thread.isOutdated || thread.subject?.isOutdated || thread.positioning?.isOutdated || false
  const commentCount = thread?.commentsData?.comments.length
  // subtract 1 because the first comment is shown in the preview
  const replyCount = commentCount ? commentCount - 1 : 0

  const repliesText = replyCount === 0 ? 'No replies' : `${replyCount} ${replyCount === 1 ? 'reply' : 'replies'}`

  return (
    <Button
      as="a"
      href={isOutdated && thread.originalDiffPathUri ? thread.originalDiffPathUri : `#r${firstComment?.databaseId}`}
      size="small"
      trailingVisual={ChevronRightIcon}
      variant="invisible"
      onClick={navigateToFirstComment}
    >
      <div className="d-flex flex-row flex-justify-start flex-items-center gap-2">
        <span>{repliesText}</span>
        <PreviewAuthors thread={thread} skipCommentById={firstComment?.id?.toString()} />
      </div>
    </Button>
  )
}
